import React, { useState } from 'react';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle';

import Modal from '~/commons/components/Modal.jsx';

const toConfirm = 'DEACTIVATE ALL';

const ModalUDeactConfirm = ({
  show,
  onReject = () => {},
  onConfirm = () => {},
}) => {
  const [confirmText, setConfirmText] = useState('');

  return (
    <Modal
      show={show}
      onHide={onReject}
      centered
    >
      <div className="p-4">
        <h4 className="text-danger">
          <FA icon={faExclamationTriangle} size="lg" />
        </h4>
        <h6 className="mt-3">
          <strong>
            You are about to deactivate all of the students&apos; accounts in the system.
          </strong>
        </h6>
        <p>
          This action cannot be undone.
          <br />
          This is designed for admin to handle graduated students
          at the end of each academic year.
        </p>
        <h2>Are you sure?</h2>

        <p>Please type <strong>{toConfirm}</strong> to confirm.</p>
        <div className="form-group">
          <input
            type="text"
            className="form-control"
            onChange={(e) => setConfirmText(e.target.value)}
          />
        </div>
        <div className="form-group">
          <button
            className="btn btn-block btn-danger"
            onClick={onConfirm}
            disabled={confirmText !== toConfirm}
          >
            Confirm
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ModalUDeactConfirm;
